import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const ConsultationBlock = () => {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section
      className="relative py-20 px-6 overflow-hidden"
      style={{ background: 'linear-gradient(135deg, #f78b49, #e63e8b)' }}
    >
      {/* Decorative circles */}
      <div className="absolute top-0 right-0 w-64 h-64 rounded-full bg-white/5 -translate-y-1/2 translate-x-1/2" />
      <div className="absolute bottom-0 left-0 w-48 h-48 rounded-full bg-white/5 translate-y-1/2 -translate-x-1/2" />

      <div
        ref={ref}
        className={`relative z-10 max-w-4xl mx-auto text-center transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
      >
        {/* Icon */}
        <div className="w-20 h-20 flex items-center justify-center rounded-full bg-white/20 border-2 border-white/40 mx-auto mb-6">
          <i className="ri-lightbulb-flash-line text-white text-3xl" />
        </div>

        {/* Badge */}
        <div className="inline-block bg-white/20 backdrop-blur-sm rounded-full px-4 py-1.5 mb-6">
          <span className="text-white text-xs font-medium tracking-wider uppercase">Consultation Obligatoire</span>
        </div>

        <h2 className="font-serif text-4xl lg:text-5xl text-white mb-4">
          Consultation Initiale
        </h2>

        <div className="flex justify-center mb-6">
          <span className="font-serif text-5xl font-bold text-white">20 000 XOF</span>
        </div>

        {/* Divider */}
        <div className="h-px w-24 bg-white/30 mx-auto mb-8" />

        {/* Features */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10 text-left">
          {[
            { icon: 'ri-search-eye-line', title: 'Analyse personnalisée', desc: 'Nous analysons votre projet dans ses moindres détails pour comprendre vos besoins.' },
            { icon: 'ri-file-list-3-line', title: "Plan d'action détaillé", desc: "Un plan d'action clair et structuré vous est remis à la suite de la consultation." },
            { icon: 'ri-price-tag-3-line', title: 'Déduit si projet confirmé', desc: 'Les frais de consultation sont déduits du devis final si vous confirmez votre projet.' },
          ].map((item) => (
            <div key={item.title} className="bg-white/15 backdrop-blur-sm rounded-xl p-5 text-white">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-white/20 mb-3">
                <i className={`${item.icon} text-lg`} />
              </div>
              <h3 className="font-semibold text-sm mb-1">{item.title}</h3>
              <p className="text-white/80 text-xs leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>

        <a
          href="mailto:hello@evcodesign-ci.com"
          className="inline-flex items-center gap-2 px-8 py-4 bg-white rounded-full text-brand-fuchsia font-medium text-sm whitespace-nowrap transition-all duration-300 hover:scale-105 cursor-pointer"
        >
          <i className="ri-calendar-event-line" />
          Réserver ma consultation
        </a>
      </div>
    </section>
  );
};

export default ConsultationBlock;
